import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { selectCurrent } from "../../../../redux/settings/selectors";
import PageLoader from "../../../../components/PageLoader";
import { selectGlobalDbnTaxonomyCategoriesCompareItem, selectGlobalDbnTaxonomyCategoriesCreatedItem, selectGlobalDbnTaxonomyCategoriesDeletedItem, selectGlobalDbnTaxonomyCategoriesListItems, selectGlobalDbnTaxonomyCategoriesUpdatedItem } from "../../../../redux/global-dbn-taxonomy-categories/selector";
import { globalDbnTaxonomyCategories } from "../../../../redux/global-dbn-taxonomy-categories/action";
import { settings } from "../../../../redux/settings/actions";
import UploadCommonModal from "../../../../models/upload-common-modal";
import { toast } from "react-toastify";
import Table from "../../../../common/components/table-manager/v1.1/table";
import Popup from "../../../../common/components/popup";
import GlobalDbnTaxonomyCompareCategories from "./global-dbn-taxonomy-compare-categories";

const GlobalDbnTaxonomyCategories = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [categoriesComparisonData, setCategoriesComparisonData] = useState<any>();
  const [categoriesListData, setCategoriesListData] = useState<any>();
  const [uploadFor, setUploadFor] = useState('create');
  const [showComparisonPopup, setShowComparisonPopup] = useState<boolean>(false);
  const { header, footer, currency } = result
  const { getUploadModal } = useAppSelector(selectCurrent)
  const listGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesListItems)
  const createGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesCreatedItem)
  const compareGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesCompareItem)
  const updateGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesUpdatedItem)
  const deleteGlobalDbnTaxonomyCategoryData = useSelector(selectGlobalDbnTaxonomyCategoriesDeletedItem)
  const [columnDefs, setColumnDefs] = useState({});
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);

  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text', },
      { field: 'GlobalDBNDomainName', headerName: 'Domain Name', searchField: 'GlobalDBNDomainName', sortable: true, filter: true, filterType: 'text', },
      { field: 'IsSubCategory', headerName: 'Sub Category', sortable: true, filter: true, filterType: 'text', cellRenderer: 'yesNoRenderer' },
      { field: 'ParentCategoryName', headerName: 'Parent Category', searchField: 'ParentCategoryName', sortable: true, filter: true, filterType: 'text' },
      { field: 'Code', headerName: 'Code', searchField: 'Code', sortable: true, filter: true, filterType: 'text', }
    ]);
  }

  const fetchGlobalDbnTaxonomyCategories = async () => {
    await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomyCategories.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
      entity: 'globalDbnTaxonomyCategories',
      jsonData:
      {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const handleSelect = (data: any) => {
    // console.log('select data', data)
  }

  const handleEdit = (data: any) => {
    navigate(`${data.GlobalDBNCategoryId}`)
  }

  const handleSearch = async (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column || data?.searchCriteriaList,
        FieldText: data?.column || data?.searchCriteriaList,
        FieldType: 'text',
        FilterOperatorId: data?.filterOperatorId || 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'list' }))
    await dispatch(globalDbnTaxonomyCategories.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/dbn-fetch`,
      entity: 'globalDbnTaxonomyCategories',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "GlobalDBNCategoryId",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleDownloadTemplate = () => {
    const fileUrl = require('../../../../assets/data/category_template.csv');
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "category_template.csv"); // Optional: Specify the file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const additionButtons: any = [
    // {
    //   name: 'Add Categories',
    //   callback: () => handleAdd(),
    // },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Import Categories</title>
          <path d="M3.00012 14L3.23397 14.6626C4.14412 17.2413 4.5992 18.5307 5.63754 19.2654C6.67588 20 8.04322 20 10.7779 20H13.2224C15.957 20 17.3244 20 18.3627 19.2654C19.401 18.5307 19.8561 17.2413 20.7663 14.6626L21.0001 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
          <path d="M12.0001 14V4M12.0001 14C11.2999 14 9.99165 12.0057 9.50012 11.5M12.0001 14C12.7003 14 14.0086 12.0057 14.5001 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Import Categories',
      callback: () => handleUploadCategoriesClick(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
          <title>Compare Categories</title>
          <path d="M19 17L19 11C19 8.17157 19 6.75736 18.1213 5.87868C17.2426 5 15.8284 5 13 5H10M10 5C10 4.29977 11.9943 2.99153 12.5 2.5M10 5C10 5.70023 11.9943 7.00847 12.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5 7.5L5 13.5C5 16.3284 5 17.7426 5.87868 18.6213C6.75736 19.5 8.17157 19.5 11 19.5H14M14 19.5C14 20.2002 12.0057 21.5085 11.5 22M14 19.5C14 18.7998 12.0057 17.4915 11.5 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="19" cy="19" r="2" stroke="currentColor" stroke-width="1.5" />
          <circle cx="5" cy="5" r="2" stroke="currentColor" stroke-width="1.5" />
        </svg>,
      // name: 'Compare Categories',
      callback: () => handleCompareCategoriesClick(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none">
          <title>Download Template</title>
          <path d="M4 7C4.58984 7.60684 6.15973 10 7 10C7.84027 10 9.41016 7.60684 10 7M7 9L7 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M4 13L4 14.5442C4 17.7892 4 19.4117 4.88607 20.5107C5.06508 20.7327 5.26731 20.9349 5.48933 21.1139C6.58831 22 8.21082 22 11.4558 22C12.1614 22 12.5141 22 12.8372 21.886C12.9044 21.8623 12.9702 21.835 13.0345 21.8043C13.3436 21.6564 13.593 21.407 14.0919 20.9081L18.8284 16.1716C19.4065 15.5935 19.6955 15.3045 19.8478 14.9369C20 14.5694 20 14.1606 20 13.3431V10C20 6.22876 20 4.34315 18.8284 3.17157C17.6569 2 15.7712 2 12 2M13 21.5V21C13 18.1716 13 16.7574 13.8787 15.8787C14.7574 15 16.1716 15 19 15H19.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleDownloadTemplate(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  const handleReloadData = () => {
    fetchGlobalDbnTaxonomyCategories();
  }

  const handleUploadCategoriesClick = () => {
    setUploadFor('create')
    dispatch(settings.set({ getUploadModal: 'open' }))
  };

  const handleCompareCategoriesClick = () => {
    setUploadFor('compare')
    dispatch(settings.set({ getUploadModal: 'open' }))
  };

  const handleDelete = async (data: any) => {
    await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'delete' }))
    await dispatch(globalDbnTaxonomyCategories.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/delete`,
      entity: 'globalDbnTaxonomyCategories',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.GlobalDBNCategoryId
          }
        ]
      }
    })).then(() => {
      fetchGlobalDbnTaxonomyCategories();
    });
  }

  const handleUploadClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',
      data
    );
    await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCreate' }))
    await dispatch(globalDbnTaxonomyCategories.uploadCreate({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/upload-global-dbn-categories`,
      entity: 'uploadCategories',
      jsonData:
        frmData
    })).then(() => {
      toast.info(
        'Categories uploading is in progress',
      );
      handleUploadClose()
    }).then(() => {
      fetchGlobalDbnTaxonomyCategories();
    })
  };

  const handleCompareClick = async (data: any) => {
    const frmData = new FormData();
    frmData.append(
      'formFile',
      data
    );
    await dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCompare' }))
    await dispatch(globalDbnTaxonomyCategories.uploadCompare({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-categories/compare-dbn-categories`,
      entity: 'compareCategories',
      jsonData:
        frmData
    })).then(() => {
      toast.info(
        'Categories compare is in progress',
      );
      handleUploadClose()
    }).then(() => {
      // showComparisonResult();
    })
  };

  const onClose = () => {
    setShowComparisonPopup(false)
  }

  const ShowComparisonResult = ({ data, onClose }: any) => {
    dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCompare' }))
    return (
      <>
        <Popup onClose={onClose}>
          <GlobalDbnTaxonomyCompareCategories data={data} onClose={onClose} />
        </Popup>
      </>
    )
  }

  const handleUploadClose = () => {
    dispatch(settings.set({ getUploadModal: 'close' }))
  }
  
  useEffect(() => {
    const searchCriteria: any = listGlobalDbnTaxonomyCategoryData?.result?.items
      ?.filter((item: any) => item?.Message?.SpecificationAttributeName) // Filter out items with falsy SpecificationAttributeName
      ?.map((item: any) => ({
        FieldName: item.Message.SpecificationAttributeName,
      }));
    setSearchCriteriaList(searchCriteria)
  }, [listGlobalDbnTaxonomyCategoryData]);

  useEffect(() => {
    if (listGlobalDbnTaxonomyCategoryData?.isSuccess) {
      setCategoriesListData(listGlobalDbnTaxonomyCategoryData)
      dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'list' }))
    }
  }, [listGlobalDbnTaxonomyCategoryData]);

  useEffect(() => {
    if (createGlobalDbnTaxonomyCategoryData?.isSuccess) {
      dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'create' }))
      fetchGlobalDbnTaxonomyCategories();
      toast.info('Category created successfully.')
    }
  }, [createGlobalDbnTaxonomyCategoryData]);

  useEffect(() => {
    if (updateGlobalDbnTaxonomyCategoryData?.isSuccess) {
      dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'update' }))
      toast.info('Category updated successfully.')
    }
  }, [updateGlobalDbnTaxonomyCategoryData]);

  useEffect(() => {
    if (deleteGlobalDbnTaxonomyCategoryData?.isSuccess) {
      dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'delete' }))
      toast.info('Category deleted successfully.')
    }
  }, [deleteGlobalDbnTaxonomyCategoryData]);

  useEffect(() => {
    if (compareGlobalDbnTaxonomyCategoryData?.isSuccess) {
      setCategoriesComparisonData(compareGlobalDbnTaxonomyCategoryData)
      setShowComparisonPopup(true)
      dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCompare' }))
      // toast.info('Comparison completed successfully.')
    }
  }, [compareGlobalDbnTaxonomyCategoryData]);

  useEffect(() => {
    createColumnDefs()
    fetchGlobalDbnTaxonomyCategories()
    setShowComparisonPopup(false)
    dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'create' }))
    dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCreate' }))
    dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'uploadCompare' }))
    dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'update' }))
    dispatch(globalDbnTaxonomyCategories.resetAction({ actionType: 'delete' }))
  }, [pageData, pageSize])

  return (
    <>
      {uploadFor === 'create' && getUploadModal == 'open' && <UploadCommonModal title='Import Categories' onSubmit={handleUploadClick} handleClose={handleUploadClose} />}
      {uploadFor === 'compare' && getUploadModal == 'open' && <UploadCommonModal title='Compare Categories' onSubmit={handleCompareClick} handleClose={handleUploadClose} />}
      {showComparisonPopup && <ShowComparisonResult data={categoriesComparisonData} onClose={onClose} />}
      {listGlobalDbnTaxonomyCategoryData?.isLoading ||
        createGlobalDbnTaxonomyCategoryData?.isLoading ||
        updateGlobalDbnTaxonomyCategoryData?.isLoading ||
        deleteGlobalDbnTaxonomyCategoryData?.isLoading ||
        compareGlobalDbnTaxonomyCategoryData?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs}
          rowData={categoriesListData?.result?.items}
          enableFilter={true}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={categoriesListData?.result?.pagination}
          onSearch={handleSearch}
          searchCriteriaList={searchCriteriaList}
          onSelect={handleSelect}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'GlobalDBNCategoryId',
          }}
          headingName="Global DBN Taxonomy Categories"
        />
      }
    </>
  );
};

export default GlobalDbnTaxonomyCategories;


